import { render, staticRenderFns } from "./InvoiceMX.vue?vue&type=template&id=2928eb48"
import script from "./InvoiceMX.vue?vue&type=script&lang=js"
export * from "./InvoiceMX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports